import { BrowserViewportFactory } from 'pf-frontend-common/src/module/browser/viewport.factory';
import { EventEmitterFactory } from 'pf-frontend-common/src/module/event/emitter.factory';
import { StatsAttributionService } from 'pf-frontend-common/src/service/stats-attribution/service';
import { StatsDataService } from 'pf-frontend-common/src/service/stats-data/service';
import { WindowLocationService } from 'pf-frontend-common/src/service/window-location/service';

import { AgentStatsDataAdapterFactory } from 'common/data/agent/stats/data-adapter.factory';
import { AgentSerpStore } from 'common/module/agent-serp/store';
import { AgentStoreService } from 'common/service/agent-store/service';
import { StatsService } from 'common/service/stats/service';
import { AgentTabListViewStore } from 'desktop/module/agent/tab/list/view-store';

// TODO-FE[WEB-1602]: Ensure this uses the common AgentListViewStore
export function AgentTabListViewStoreFactory(agentSerpStore: AgentSerpStore): AgentTabListViewStore {
  return new AgentTabListViewStore(
    EventEmitterFactory(),
    AgentStoreService(),
    agentSerpStore,
    StatsService(),
    StatsDataService(),
    StatsAttributionService(),
    AgentStatsDataAdapterFactory(),
    WindowLocationService(),
    BrowserViewportFactory()
  );
}
